import { combineReducers } from '@reduxjs/toolkit';
import gameReducer from './game';

const appReducer = combineReducers({
  game: gameReducer,
});

export default appReducer;
